mutation AddNewStarter(
  $employeeId: ID
  $email: String
  $firstName: String
  $lastName: String
  $title: String
  $teamId: ID
  $startDate: ISO8601Date
  $trainingRequired: Boolean
  $navigatorAccess: Boolean
) {
  addNewStarter(
    input: {
      employeeId: $employeeId
      email: $email
      firstName: $firstName
      lastName: $lastName
      title: $title
      teamId: $teamId
      startDate: $startDate
      trainingRequired: $trainingRequired
      navigatorAccess: $navigatorAccess
    }
  ) {
    employee {
      id
    }
  }
}
